import { Trash2 } from 'lucide-react';

import { useTranslation } from '../../i18n';
import { useDeleteRoom } from '../../hooks/queries/useSpaceQueries';
import { IRoom } from '../../types';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

interface IRoomDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  room: IRoom | null;
}

const RoomDeleteDialog = ({
  isOpen,
  onClose,
  room,
}: IRoomDeleteDialogProps) => {
  const { t } = useTranslation();
  const deleteRoom = useDeleteRoom();

  const handleConfirm = async () => {
    if (!room) return;

    await deleteRoom.mutateAsync(room.id);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>{t('rooms.delete_title')}</DialogTitle>
          <DialogDescription>
            {t('rooms.delete_confirm', { name: room?.name ?? '' })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={deleteRoom.isPending}
          >
            <Trash2 className="w-4 h-4" />
            {deleteRoom.isPending
              ? t('common.saving')
              : t('rooms.confirm_delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RoomDeleteDialog;
